import React from 'react'
import { Card, type CardProps } from '@mantine/core'

export type AppCardProps = CardProps;

export default function AppCard ({ withBorder = true, radius = 'md', ...props }: AppCardProps) {
  return <Card withBorder={withBorder} radius={radius} {...props} />
}
